// extracted by mini-css-extract-plugin
module.exports = {"grid":"SalesApplicationPaymentStepOverview_grid_1xQEe"};